import { useMutation } from "@tanstack/react-query";
import { getAuthMethod } from "../modules/helper";

const useCity = () => {
  const { mutateAsync } = useMutation({
    mutationKey: ["cityByProviceId"],
    mutationFn: id =>
      getAuthMethod("/address/v1/city/show/" + id).then(res => {
        if (res.status === 200) {
          return res.data.data;
        }

        return [];
      }),
  });

  return { getCitiesByProviceId: mutateAsync };
};

export default useCity;
